import ServerDirections from '@/config/server-directions'
import { Booking } from '@/entities/Booking'
import { Room } from '@/entities/Room'
import { Guest } from '@/entities/Guest'
import { AccountDetails } from '@/entities/AccountDetails'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

var snakeCaseKeys = require('snakecase-keys')

export class BookingRequests {
  get (id) {
    function map (data) {
      return new Booking(data)
    }
    const route = ServerDirections.BOOKINGS_ID.replace('{id}', id)
    const method = 'get'
    return requestService.makePromise(route, method, {}, map)
  }
  getBookingRooms (bookingId) {
    function map (data) {
      return data.map((r) => {
        return {
          room: new Room(r.room),
          account: r.account ? new AccountDetails(r.account) : null,
          roomId: r.room.id
        }
      })
    }
    const route = ServerDirections.BOOKINGS_ID_ROOMS.replace('{id}', bookingId)
    const method = 'get'
    return requestService.makePromise(route, method, {}, map)
  }
  save (booking) {
    function map (data) {
      return data.id
    }
    const route = ServerDirections.BOOKINGS
    const method = 'post'
    const body = snakeCaseKeys(booking)
    return requestService.makePromise(route, method, { body }, map)
  }
  roomAccount (bookingId, roomId, accountId) {
    const route = ServerDirections.BOOKINGS_ID_ROOMS_ID_ACCOUNTS_ID.replace('{bookingId}', bookingId).replace('{roomId}', roomId).replace('{accountId}', accountId)
    const method = 'put'
    const body = {}
    function map (data) {
      return data
    }
    return requestService.makePromise(route, method, { body }, map)
  }
  getBookingGuests (bookingId) {
    function map (data) {
      return data.map((g) => new Guest(g))
    }
    const route = ServerDirections.BOOKINGS_ID_GUESTS.replace('{id}', bookingId)
    const method = 'get'
    return requestService.makePromise(route, method, {}, map)
  }
}